export const GET_CONFIG = 'GET_CONFIG';
export const SET_CONFIG = 'SET_CONFIG';
export const GET_CARD_PAYMENT = 'GET_CARD_PAYMENT';
export const SET_CARD_PAYMENT = 'SET_CARD_PAYMENT';
export const GET_GLOVO_ENABLED_STATUS = 'GET_GLOVO_ENABLED_STATUS';
export const SET_ENABLE_GLOVO = 'SET_ENABLE_GLOVO';
export const SET_DISABLE_GLOVO = 'SET_DISABLE_GLOVO';
export const SET_WOLT_ENABLED = 'SET_WOLT_ENABLED';

export const SET_DELIVERY_PROVIDER_ENABLED = 'SET_DELIVERY_PROVIDER_ENABLED';
export const GET_DELIVERY_PROVIDERS = 'GET_DELIVERY_PROVIDERS';
